<template>
  <div class="categoriesMainWrap">
    <div class="sixteentosix sixteentosix-wrap omt-6 omt-md-25">
      <div class="new-background-wrap">
        <div class="sto_newsletter">
          <v-btn @click="redirectToSubcriptionPage()">
            <img src="/static/img/newsletter_ev.svg" />
            {{ $t("subscribe_to_our_newsletter") }}
          </v-btn>
        </div>
        <div
          class="kachelimage header-image zoom-image"
          style="
            background: url('/static/img/Training_Academy_Banner_login_2.jpg');
            background-position: top !important;
          "
        ></div>
        <!-- <img src="/static/img/Training_Academy_Banner_login_2.jpg" /> -->
        <div class="headline-wrap">
          <div class="headline">
            <div class="text-subtitle-2 text-md-h5">
              {{ $t("welcome_homepage") }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="pl-md-12 col-md-12 col-xl-7 right-side-block trn_search">
      <div class="mt-6"></div>
      <v-text-field
        hide-details="auto"
        class="justify-content-end searchbar align-self-center pb-1 categorySearch"
        style="padding-right: 2px"
        dense
        outlined
        v-model="search"
        @keypress.enter="redirectToSearchPage()"
        :label="$t('search')"
        ><template v-slot:append>
          <v-icon color="#003A60">fas fa-search</v-icon>
        </template></v-text-field
      >
    </div>
    <div>
      <div class="align-items-start">
        <!-- Left Area -->
        <div class="">
          <div class="pl-8 pl-md-12 mx-0 pa-0 left__spacing">
            <h3>{{ $t("our_training_portfolio") }}</h3>
            <div class="divider"></div>
          </div>
          <div class="pl_items">
            <div class="row">
              <div
                class="mx-0 col-xl-4 col-md-6"
                v-for="category in categories"
                :key="category.id"
              >
                <div class="category-box">
                  <v-card
                    flat
                    class="no-border-radius sixteentonine"
                    height="100%"
                    :to="'/category?categoryId=' + category.id"
                  >
                    <v-img
                      class="kachelimage"
                      height="100%"
                      :src="`/files/images/${category.image}`"
                    ></v-img>
                    <div
                      class="text-md-h6 pl-8 pl-md-12 py-1 bottom-row bg-blue"
                    >
                      {{ category.designationMap[$locale] }}
                    </div>
                  </v-card>
                </div>
              </div>
              <div class="mx-0 col-12 pb-0">
                <div class="category-box">
                  <v-card
                    flat
                    class="no-border-radius"
                    style="min-height: 210px"
                    @click="openRailServicesWebsite()"
                  >
                    <v-img
                      class="kachelimage"
                      height="100%"
                      src="/static/img/secondbanner.jpg"
                    ></v-img>
                    <div class="headline bottom-banner">
                      <div class="text-subtitle-2 text-md-h5-snd">
                        {{ $t("welcome_homepage_secondbanner") }}
                      </div>
                    </div>
                  </v-card>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- dialog for newsletter subscription -->
        <v-dialog v-model="dialog" content-class="sto_newsletter_popup">
          <img
            @click="clearData"
            class="nl_close"
            src="/static/img/newsletter_close.svg"
          />
          <img class="nl_img" src="/static/img/newsletter_ev.svg" />
          <h3 class="align_center">{{ $t("subscribe_to_our_newsletter") }}</h3>
          <p class="nl_p1">{{ $t("enter_your_email_to_updated") }}</p>
          <div class="d-flex name_input_manage">
            <v-text-field
              hide-details="auto"
              class="datainput justify-content-end align-self-center pb-1 sto_newsletter_select_first"
              dense
              outlined
              :label="$t('enter_your_firstname')"
              v-model="subscription.firstName"
              :error-messages="validationErrors.firstName"
              @input="clearFirstNameError"
            ></v-text-field>

            <v-text-field
              hide-details="auto"
              class="datainput justify-content-end align-self-center pb-1 sto_newsletter_select_first"
              dense
              outlined
              :label="$t('enter_your_lastname')"
              v-model="subscription.lastName"
              :error-messages="validationErrors.lastName"
              @input="clearLastNameError"
            ></v-text-field>
          </div>
          <v-text-field
            hide-details="auto"
            class="datainput justify-content-end align-self-center pb-1 sto_newsletter_select_first"
            dense
            outlined
            :label="$t('enter_your_mail')"
            v-model="subscription.subscriptionMail"
            :error-messages="validationErrors.subscriptionMail"
            @input="clearEmailError"
          ></v-text-field>

          <v-select
            class="datainput justify-content-end align-self-center sto_newsletter_select"
            :label="$t('select_prefered_lanagauge')"
            :items="possiblelanguagesComputed"
            item-text="name"
            item-value="value"
            v-model="subscription.preferredLanguage"
            :error-messages="validationErrors.preferredLanguage"
            @change="clearLanguageError"
          >
            <template slot="item" slot-scope="data">
              <img
                style="width: 30px; height: 20px; vertical-align: unset"
                :src="'/files/flags/' + data.item.flag"
              />
              &nbsp; {{ data.item.name }}
            </template>
            <template slot="selection" slot-scope="{ item }">
              <img
                style="width: 30px; height: 20px; vertical-align: unset"
                :src="'/files/flags/' + item.flag"
              />
              &nbsp; {{ item.name }}
            </template>
          </v-select>

          <v-card-actions class="align_center">
            <v-btn
              @click="handleClick"
              outlined
              depressed
              tile
              class="savebutton mr-2 mb-2"
            >
              {{ $t("subscribe") }}
            </v-btn>
          </v-card-actions>
        </v-dialog>

        <!-- dialog for newsletter verification -->
        <v-dialog
          v-model="dialogConfirmation"
          content-class="sto_newsletter_popup"
        >
          <img
            class="nl_close"
            @click="clearDataOnSecondDialogue"
            src="/static/img/newsletter_close.svg"
          />
          <img
            class="newsletter_v_arrow"
            src="/static/img/newsletter_v_arrow.svg"
          />
          <h3 class="align_center">{{ $t("verify_your_email") }}</h3>
          <p>{{ $t("we_have_sent_a_confirmation_link_to") }}</p>
          <p class="nl_p2">{{ subscription.subscriptionMail }}</p>
          <v-card-actions class="align_center">
            <v-btn
              @click="confirmSubscription"
              outlined
              depressed
              tile
              class="savebutton mr-2 mb-2"
            >
              {{ $t("confirm_subscription") }}</v-btn
            >
          </v-card-actions>
        </v-dialog>

        <v-dialog
          v-model="dialogConfirmationFinal"
          content-class="sto_newsletter_popup"
        >
          <img
            class="nl_close"
            @click="dialogConfirmationFinal = false"
            src="/static/img/newsletter_close.svg"
          />
          <img class="newsletter_v_arrow" src="/static/img/sub_bluetick.svg" />
          <h3>{{ $t("subscription_confirmned") }}</h3>
          <p>{{ $t("thank_you_for_subscribing") }}</p>
          <p class="nl_p3">{{ $t("check_your_inbox") }}</p>
          <v-card-actions class="align_center">
            <v-btn
              @click="routeToHome"
              class="vs-btn--outlined vs-btn vs-btn--full"
            >
              {{ $t("explore_more") }}
            </v-btn>
          </v-card-actions>
        </v-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import Card from "./custom/Card.vue";
export default {
  components: {
    Card,
  },

  data() {
    return {
      categories: [],
      search: "",
      dialog: false,
      dialogConfirmation: false,
      dialogConfirmationFinal: false,
      subscription: {
        firstName: "",
        lastName: "",
        subscriptionMail: "",
        preferredLanguage: "",
      },
      validationErrors: {
        firstName: "",
        lastName: "",
        subscriptionMail: "",
        preferredLanguage: "",
      },
      unsubscribe:false
    };
  },
  computed: {
    possiblelanguagesComputed() {
      return this.$root.languageTabsNew.map((language) => ({
        name: language.translatedName,
        flag: language.flag,
        shortForm: language.shortForm,
        value: language.language,
      }));
    },
  },
  mounted() {
    if (
      this.isLoad != true &&
      !window.location.href.includes("?") &&
      !window.location.href.includes("?lang=")
    ) {
      this.isLoad = true;
      window.location.href =
        window.location.href + "?lang=" + this.$locale.toUpperCase();
    }
    this.fetchCategories();
    this.subscriptionId = this.$route.query.subscriptionId;
    if(this.$route.query.unsubscribe && this.$route.query.unsubscribe==='true'){
      this.unsubscribe=true;
      this.finalSubscrptionConfirmationUnsubscibe(this.subscriptionId);
    }
    if (this.subscriptionId) {
      this.finalSubscrptionConfirmation(this.subscriptionId);
    }
  },

  methods: {
         redirectToSubcriptionPage() {
      this.$router.push("/subscribe-module");
    },
    clearData() {
      this.dialog = false;
      this.subscription.subscriptionMail = null;
      this.subscription.preferredLanguage = null;
      this.subscription.firstName = null;
      this.subscription.lastName = null;
    },
    clearDataOnSecondDialogue() {
      this.dialogConfirmation = false;
      this.subscription.subscriptionMail = null;
      this.subscription.preferredLanguage = null;
      this.subscription.firstName = null;
      this.subscription.lastName = null;
    },
    routeToHome() {
      this.dialogConfirmationFinal = false;
      //this.$router.push("/categories");
    },
    finalSubscrptionConfirmation() {
      var _this = this;
      this.$axios
        .put("api/newsletter/" + this.subscriptionId)
        .then(function (response) {
          if (response.data.alreadySubscribed == false) {
            _this.dialogConfirmationFinal = true;
          }
        })
        .catch(this.onError);
    },
    finalSubscrptionConfirmationUnsubscibe() {
      var _this = this;
      this.$axios
        .put("api/newsletter/" + this.subscriptionId+"/unsubscribe")
        .then(function (response) {
        })
        .catch(this.onError);
    },
    confirmSubscription() {
      var _this = this;
      this.$axios
        .post("api/newsletter/", this.subscription)
        .then(function (response) {
          _this.$t("check_email");
          _this.subscription.subscriptionMail = null;
          _this.subscription.preferredLanguage = null;
          _this.subscription.firstName = null;
          _this.subscription.lastName = null;
          _this.dialogConfirmation = false;
        })
        .catch(this.onError);
    },
    validateEmail(email) {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return regex.test(email);
    },
    clearFirstNameError() {
      if (this.subscription.firstName) {
        this.validationErrors.firstName = "";
      }
    },
    clearLastNameError() {
      if (this.subscription.lastName) {
        this.validationErrors.lastName = "";
      }
    },
    clearEmailError() {
      if (this.validateEmail(this.subscription.subscriptionMail)) {
        this.validationErrors.subscriptionMail = "";
      }
    },
    clearLanguageError() {
      if (this.subscription.preferredLanguage) {
        this.validationErrors.preferredLanguage = "";
      }
    },
    handleClick() {
      // Reset validation errors
      this.validationErrors.subscriptionMail = "";
      this.validationErrors.preferredLanguage = "";
      this.validationErrors.firstName = "";
      this.validationErrors.lastName = "";

      let isValid = true;

      if (!this.subscription.firstName) {
        this.validationErrors.firstName = this.$t("valid_first_name");
        isValid = false;
      }
      if (!this.subscription.lastName) {
        this.validationErrors.lastName = this.$t("valid_last_name");
        isValid = false;
      }
      // Validate email
      if (
        !this.subscription.subscriptionMail ||
        !this.validateEmail(this.subscription.subscriptionMail)
      ) {
        this.validationErrors.subscriptionMail = this.$t("valid_email");
        isValid = false;
      }

      // Validate language selection
      if (!this.subscription.preferredLanguage) {
        this.validationErrors.preferredLanguage = this.$t(
          "select_prefred_language"
        );
        isValid = false;
      }

      if (isValid) {
        this.dialog = false;
        this.dialogConfirmation = true;
      }
    },

    redirectToSearchPage() {
      const searchTerm = this.search;
      this.$router.push("/category-training?term=" + searchTerm);
    },
    onError(err) {
      if (err.response != null && err.response.data != null) {
        this.$noty.error(err.response.data);
      } else {
        console.error(err);
      }
    },

    fetchCategories() {
      var _this = this;
      this.$axios
        .get("api/category/root")
        .then(function (response) {
          _this.categories = response.data;
        })
        .catch(this.onError)
        .finally(this.onFinally);
    },

    onFinally() {
      showLoadingCircle(false);
    },

    openRailServicesWebsite() {
      window.open("https://rail.knorr-bremse.com", "_blank").focus();
    },
  },
};
</script>
